export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        const files = require.context('@/components/', true, /\.vue$/i);
        files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

    }
}
